import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";
import AuthLoadingScreen from "./AuthLoadingScreen";

const SuperAdminGuard = () => {
  const { isAuthenticated, isInitializing, user } = useStateContext();

  if (isInitializing) return <AuthLoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (user?.role !== "super_admin") return <Navigate to="/dashboard" replace />;

  return <Outlet />;
};

export default SuperAdminGuard;